module.exports = __webpack_public_path__ + "src/assets/img/stop-small.3a9ae187.png";